import VueRouter from 'vue-router';

export default function (router: VueRouter) {
  router.push({
    name: 'Enheder'
  });
}
